// extracted by mini-css-extract-plugin
export default {"container":"AdditionalDetails_container__r+Pve","switch-container":"AdditionalDetails_switch-container__RHbeQ","switch":"AdditionalDetails_switch__4C6c3"};